import React, {useEffect} from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {GlobalConstants} from "../../globals/GlobalConstants";
import '../../styles/DataExtractionArea.css'
import {fetchAuthSession} from "aws-amplify/auth";
import Autocomplete from "@mui/material/Autocomplete";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {refreshToken} from "../../globals/GlobalFunctions";


//axios.defaults.headers.common['Authorization'] = `Bearer ${}`;

function DataExtractionArea() {
    const [extractType, setCurrentType] = React.useState( "PremRate");
    const [currentDB, setCurrentDB] = React.useState("CoastalAdmin");
    const [validationError, setValidationError] = React.useState(false);
    const [validationText, setValidationText] = React.useState("");
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [filter, setFilter] = React.useState( "none");
    const [noFilter, disableFilter] = React.useState(false);

    const onDBChange = React.useCallback((e: any, newDB: any) => setCurrentDB(newDB.id), []);

    const onExtractChange = React.useCallback((e: any, newType: any) => {
        setCurrentType(newType)
        if (newType === "") {
            disableFilter(false);
        }else {
            disableFilter(true);
            setFilter("none");
        }
    }, []);

    const onFilterChange = React.useCallback((e: any) => setFilter((prev: any) => (e.target.value)), []);

    const handleValidationClose = () => {
        setValidationError(false);
    }

    useEffect(() => {
        // This code will run after 'value' has been updated
        disableFilter(true);
    }, []);

    let token = localStorage.getItem('jwt');
    //console.log('jwt', token);

    const extractRecords = async () => {
        refreshToken();
        try {
            const response =
                await axios
                    .get(
                        localStorage.getItem('baseURL') + extractType + `/extract/` + currentDB + '/' + filter,
                        {headers: {'Authorization': `Bearer ${token}`}}
                    );

            const {fileName, contentType, data} = response.data;

            const binaryString = atob(data);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);

            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }

            const blob = new Blob([bytes], {type: contentType});
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);

            setSuccessAlert(true);
        } catch (error: any) {
            console.error('Data Extract Error: ', error);

            if (error?.response) {
                setValidationText(`Backend error: ${error.response.status} ${error.response.statusText}`);
            } else if (error?.request) {
                setValidationText('No response from backend. Make sure the API is running.');
            } else {
                setValidationText('There was an error generating the PremRate Extract report.');
            }

            setValidationError(true);
        } finally {
            setLoading(false);
        }

    }

    const validateExtract = () => {
        setLoading(true);
        if((!noFilter && filter.length <= 0)){
            setLoading(false);
            setValidationText("Filter is required for this extract");
            setValidationError(true);
        }
        else {
            extractRecords();
        }
    }

    return (
        <div className="dataExtractPageWrap">
            <div className="dataExtractReportCard">
                <span className="typeLabel">
                    Extract Type:
                </span>
                <div className="selectArea">
                    <Autocomplete
                        className="typeSelect"
                        size={"small"}
                        disablePortal
                        disableClearable
                        options={GlobalConstants.ExtractAreas}
                        value={GlobalConstants.ExtractAreas.find(option => option === extractType) || null}
                        defaultValue={GlobalConstants.ExtractAreas[1]}
                        renderInput={(params) => <TextField {...params}  />}
                        onChange={onExtractChange}
                    />
                </div>
                <div className="extractLabelWrap">
                    <span className="extractLeftLabels">
                            Extract Filter
                        </span>
                    {/*<span style={{display: "inline-block", width: "20%"}}></span>*/}
                </div>
                <div className="extractInputWrapper">
                    {/*<span style={{display: "inline-block", width: "25%"}}></span>*/}
                    <TextField name="filter" variant="outlined" className="extractInput" size="small" type="text"
                               value={filter} onChange={onFilterChange} disabled={noFilter}/>
                    {/*<span style={{display: "inline-block", width: "23%"}}></span>*/}
                </div>
                <div className="extractButtonWrapper">
                    <Stack direction="row">
                        {/*<Button variant="contained" onClick={getUsers}>Get Users</Button>*/}
                        <LoadingButton className="extractButtonz" variant="contained" onClick={validateExtract} loading={loading}
                                       loadingPosition="start"
                                       startIcon={<DeleteForeverIcon/>}>Extract</LoadingButton>
                    </Stack>
                </div>
                <Dialog
                    open={validationError}
                    onClose={handleValidationClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {"Validation Error"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {validationText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleValidationClose}>OK</Button>
                    </DialogActions>
                </Dialog>
                {successAlert ?
                    <Alert className="extractAlertStyles" severity='success' onClose={() => setSuccessAlert(false)}
                           variant="filled">
                        <AlertTitle>Success!</AlertTitle>
                        Extract Successful!
                    </Alert> : <></>}
            </div>
            <Stack direction="row" className="extractButtonBar">
                <Autocomplete
                    className="extractDbContractSelect"
                    size={"small"}
                    disablePortal
                    disableClearable
                    options={GlobalConstants.VBA_DB}
                    value={GlobalConstants.VBA_DB.find(option => option.id === currentDB) || null}
                    sx={{width: 150}}
                    defaultValue={GlobalConstants.VBA_DB[0]}
                    renderInput={(params) => <TextField {...params}  />}
                    onChange={onDBChange}
                />
            </Stack>
            <Backdrop
                sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
                open={loading}
            >
                <CircularProgress color="inherit"/>
            </Backdrop>
        </div>
    )
}

export default React.memo(DataExtractionArea);